<template>
  <div>
    <SectionHeader>
      <h1>
        Steam Account Transfer
      </h1>
    </SectionHeader>
    <SectionWrapper class="whiteframe shadowframe">
      <Icon type="check" color="green" :size="3" />
      <p>
        Your Steam Account has been succesfully transfered
      </p>
    </SectionWrapper>
    <DividerSeparator>
      <DecoratedButton
        type="link"
        :route="{ name: pages.AUTH_LOGIN }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        LOGIN
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
export default {
  name: "form-transfer-success"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
